import './countdown.less'

import {Icon} from '@codeurs/front'
import {differenceInMilliseconds, isValid} from 'date-fns'
import {zonedTimeToUtc} from 'date-fns-tz'
import React, {useEffect, useState} from 'react'
import {LinkType, WysiwygType} from 'types'
import {Link} from 'util/link'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('countdown', ['item'])

export type CountdownType = {
	show?: boolean
	date: string
	text?: WysiwygType
	button?: LinkType
	complete_text?: WysiwygType
	complete_button?: LinkType
}

export const Countdown: React.FC<CountdownType> = ({
	show,
	date,
	text,
	button,
	complete_text,
	complete_button
}) => {
	if (!show) return null
	const fromZonedTime = zonedTimeToUtc(date, 'Europe/Brussels')
	if (!isValid(fromZonedTime)) return null

	const [isNow, setNow] = useState(new Date())
	const now = isNow

	useEffect(() => {
		setNow(new Date())
	}, [now])

	let ms = differenceInMilliseconds(fromZonedTime, now) / 1000

	const days = Math.floor(ms / 86400)
	ms -= days * 86400

	const hours = Math.floor(ms / 3600) % 24
	ms -= hours * 3600

	const min = Math.floor(ms / 60) % 60
	ms -= min * 60

	const sec = Math.floor(ms % 60)

	const visibleText = days < 0 ? complete_text : text
	const visibleButton = days < 0 ? complete_button : button

	if (!visibleText && !visibleButton) return null

	return (
		<div className={styles().mod({button})}>
			{visibleText && (
				<div className={styles('text')}>
					<Theme.Wysiwyg>{visibleText}</Theme.Wysiwyg>
				</div>
			)}
			{days >= 0 && (
				<div className={styles('row')}>
					<CountdownItem label={'days'} number={days} />
					<CountdownItem label={'hours'} number={hours} />
					<CountdownItem label={'minutes'} number={min} />
					<CountdownItem label={'seconds'} number={sec} />
				</div>
			)}
			{visibleButton?.url && (
				<Link to={visibleButton?.url} className={styles('button')}>
					{visibleButton?.description || visibleButton?.title}
					<span className={styles('button-icon')}>
						<Icon icon="arrow-right" />
					</span>
				</Link>
			)}
		</div>
	)
}

const CountdownItem: React.FC<{label: string; number: number}> = ({
	label,
	number
}) => {
	return (
		<div className={styles.item()}>
			<span className={styles.item('number')}>{number}</span>
			<span className={styles.item('label')}>{label}</span>
		</div>
	)
}
